export const contact = {
  // Hero Section
  badge: 'EDUSPACE Philippines',
  heroTitle: '문의하기',
  heroSubtitle: '초등 4-5학년 우주 교육 프로그램 문의를 환영합니다',

  // Contact Information
  getInTouch: '연락처',
  addressLabel: '주소',
  addressLine1: '11F and 16F Strata 100 Building',
  addressLine2: 'Emerald Ave., Ortigas Center',
  addressLine3: 'Pasig City, Philippines',
  phoneLabel: '전화',
  phoneNumber: '+632 5310 5375',
  phoneNote: '(11층 사무실)',
  emailLabel: '이메일',
  emailAddress: 'teachers.ican@gmail.com',
  hoursLabel: '운영 시간',
  hoursWeekdays: '평일: 09:00 - 21:00',
  hoursWeekends: '주말: 10:00 - 18:00',
  followUs: '팔로우하기',

  // Contact Form
  formTitle: '문의하기',
  nameLabel: '이름',
  namePlaceholder: '이름을 입력하세요',
  emailLabel: '이메일',
  emailPlaceholder: '이메일을 입력하세요',
  subjectLabel: '제목',
  subjectPlaceholder: '문의 제목을 입력하세요',
  messageLabel: '메시지',
  messagePlaceholder: 'EDUSPACE 프로그램에 대해 궁금한 점을 작성해주세요...',
  characterCount: '자',
  submitButton: '문의 보내기',

  // Map Section
  mapTitle: '오피스',
  mapTitleHighlight: '방문하기',
  mapLocation: '11층과 16층에 위치',

  // Alert Messages
  successMessage: 'Thank you for your inquiry! We will get back to you soon.',
  successMessageKo: '문의해주셔서 감사합니다! 빠른 시일 내에 답변드리겠습니다.'
};
